<template>
  <Dialog
    title="导入学员"
    :visible.sync="uploadVisible"
    :close-on-click-modal="false"
    width="400px"
    :before-close="uploadCancel"
  >
    <el-upload
      action="#"
      ref="uploadRef"
      accept=".xlsx"
      :on-change="handleChange"
      multiple
      :auto-upload="false"
      :disabled="uploadLoading"
      drag
      :limit="1"
    >
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">
        将文件拖到此处，或<em>点击上传</em>
        <div>支持文件格式xlsx，仅支持单个文件上传</div>
      </div>
      <div class="el-upload__tip text-center" slot="tip">
        <div>1.学员表格中，需按正规格式填写所有内容项，不得为空</div>
        <div>
          2.学员表格中，学员信息重复，或部分信息重复，将无法导入，如：手机号、身份证号重复
        </div>
      </div>
    </el-upload>
    <div slot="footer">
      <el-button
        plain
        round
        size="small"
        @click="downloadTemp"
        icon="el-icon-download"
        type="text"
        >下载模板</el-button
      >
      <el-button plain round size="small" @click="uploadCancel"
        >取 消</el-button
      >
      <el-button
        plain
        round
        size="small"
        type="primary"
        :loading="uploadLoading"
        @click="uploadSubmit"
        >确 定</el-button
      >
    </div>
  </Dialog>
</template>

<script>
import { importStudent } from "@/api/student";

export default {
  data() {
    return {
      fileList: [],
      uploadVisible: false,
      uploadLoading: false
    };
  },
  methods: {
    async downloadTemp() {
      const res =
        process.env.NODE_ENV === "production"
          ? "./static/学员导入模板.xlsx"
          : "/static/学员导入模板.xlsx";
      window.open(res);
    },
    handleChange(file, fileList) {
      if (file.name.split(".").slice(-1) == "xlsx") {
        this.fileList = fileList;
      } else {
        this.$refs.uploadRef.clearFiles();
        this.$message({
          type: "warning",
          message: "请上传xlsx文件"
        });
      }
    },
    uploadCancel() {
      this.uploadVisible = false;
      this.$refs.uploadRef.clearFiles();
      this.fileList = [];
    },
    open() {
      this.uploadVisible = true;
    },
    async uploadSubmit() {
      if (this.uploadLoading) return;
      this.uploadLoading = true;
      try {
        if (this.fileList.length > 0) {
          try {
            const uploadForm = new FormData();
            uploadForm.append("file", this.fileList[0].raw);
            const res = await importStudent(uploadForm);
            // this.uploadCancel();
            // this.$emit("success");
            if (res.data && res.data.code === 500) {
              this.$message.error(res.data.msg);
            } else {
              this.uploadCancel();
              this.$message.success("上传成功!");
              this.$emit("success");
            }
          } finally {
            this.$refs.uploadRef.clearFiles();
            this.fileList = [];
          }
        } else {
          this.$message.info("请选择文件");
        }
      } finally {
        this.uploadLoading = false;
      }
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/students/UploadForm.vue